import Vue from 'vue'
import { ARTICLES } from '@/api'
import errorHandling from './exceptions'

/**
 * Retorna uma collection de artigos com base
 * nos parâmetros informados.
 *
 * @param {object}   params
 * @param {function} callback
 */
const index = (params, callback) => {
  Vue.axios.get(ARTICLES, { params })
    .then(res => {
      if (typeof res.data.meta !== 'undefined') {
        callback(res.data.articles, res.data.meta.pagination)
      } else {
        callback(res.data.articles)
      }
    })
    .catch(errorHandling)
}

/**
 * Alias para o método 'index' com o parâmetro
 * 'search_term' já embutido.
 *
 * @param {string}   term
 * @param {function} callback
 */
const search = (term, callback) => {
  index({ search_term: term }, callback)
}

/**
 * Retorna os detalhes de um artigo com base
 * em sua ID.
 *
 * @param {integer}  id
 * @param {function} callback
 */
const find = (id, callback) => {
  Vue.axios.get(ARTICLES + '/' + id)
    .then(res => {
      callback(res.data)
    })
    .catch(errorHandling)
}

/**
 * Busca pelos dados de um artigo com base
 * em sua slug.
 *
 * @param {integer}  product
 * @param {string}   slug
 * @param {function} callback
 */
const findBySlug = (product, slug, callback) => {
  index({ filter_attrs: { product_id: product, slug } }, articles => {
    let article = null

    if (articles.length > 0) {
      article = articles[0]
    }

    callback(article)
  })
}

/**
 * Salva os dados de um novo artigo.
 *
 * @param {object}   data
 * @param {function} callback
 * @param {function} errorCallback
 */
const store = (data, callback, errorCallback) => {
  Vue.axios.post(ARTICLES, data)
    .then(res => {
      callback(res.data)
    })
    .catch(errorCallback)
}

/**
 * Atualiza os dados de um artigo.
 *
 * @param {integer}  id
 * @param {object}   data
 * @param {function} callback
 * @param {function} errorCallback
 */
const update = (id, data, callback, errorCallback) => {
  Vue.axios.put(ARTICLES + '/' + id, data)
    .then(res => {
      callback(res.data)
    })
    .catch(errorCallback)
}

/**
 * Remove um artigo com base em sua ID.
 *
 * @param {integer}  id
 * @param {function} callback
 */
const destroy = (id, callback) => {
  Vue.axios.delete(ARTICLES + '/' + id)
    .then(callback)
    .catch(errorHandling)
}

export default {
  index,
  search,
  find,
  findBySlug,
  store,
  update,
  destroy
}
